import type { OpenSettingsInput } from "@/utils/settingsNavigation";
import { createContext, useContext } from "react";

const OpenSettingsContext = createContext<
  ((input?: OpenSettingsInput) => void) | null
>(null);

export function useOpenSettings(): (input?: OpenSettingsInput) => void {
  const fn = useContext(OpenSettingsContext);
  return fn ?? (() => {});
}

export const OpenSettingsProvider = OpenSettingsContext.Provider;
